import React from 'react';

const BeetleEffect = () => (
  <div
    style={{
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
    }}
  >
    <div
      style={{
        position: 'absolute',
        top: '45%',
        left: '-2%',
        fontSize: '110px',
        animation: 'egg-beetle 22s linear forwards',
      }}
      aria-hidden="true"
    >
      🪲💩
    </div>
    <div
      style={{
        position: 'absolute',
        top: '55%',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '80px',
        opacity: 0,
        animation: 'egg-boom 2.2s ease-out 17s forwards',
      }}
      aria-hidden="true"
    >
      💥
    </div>
  </div>
);

export default BeetleEffect;

